module.exports = __webpack_public_path__ + "static/media/dormir.d43ef1a7.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/dormir.png
// module id = 918
// module chunks = 0